import { readActorType } from "@/lib/analytics";
import { useOrderAssistantEnabled } from "@/queries/order-assistant";

import { OrderAssistantButton } from "./OrderAssistantButton";
import { OrderAssistantDrawer } from "./OrderAssistantDrawer";
import { OrderAssistantProvider } from "./OrderAssistantProvider";

/**
 * The order assistant's button and drawer, mounted once in `MainLayout`.
 *
 * Offered only to a signed-in salon, and only when the service says it is on
 * (`GET /store/agent/status`). Never in a concierge operator's session: an operator
 * shops as the salon's own customer id, and the assistant would read that
 * salon's order history and spend its message allowance (the same actor check
 * as the analytics blackout - `readActorType`).
 *
 * The provider is keyed by customer, so a different salon signing in on this tab
 * never inherits the previous one's conversation.
 */
export function OrderAssistant({ customerId }: { customerId: string }) {
  const enabled = useOrderAssistantEnabled(customerId);
  if (!enabled || !customerId || readActorType() === "concierge_operator") {
    return null;
  }

  return (
    <OrderAssistantProvider key={customerId} customerId={customerId}>
      <OrderAssistantButton />
      <OrderAssistantDrawer />
    </OrderAssistantProvider>
  );
}
